define("js/utils/scroll-to",["jquery"],function(t){"use strict";return function(n){t("html, body").animate({scrollTop:n},500)}});
